import { MedisanteDevice } from '../Device/types';
import { ReactElement } from 'react';

export interface ListDecoratedMedisanteDevice extends MedisanteDevice {
  readonly selected: boolean;
  readonly statuses?: {
    [key in StatusesKeys]: boolean;
  };
}

export type StatusesSortValues = {
  [key in StatusesKeys]: number;
};

export const alertsSortingValues: StatusesSortValues = {
  isBehindSyncingSchedule: 1,
  hasLowBattery: 1,
  hasMinBattery: 1,
  hasLowSignalStrength: 1,
  hasMinSignalStrength: 1,
  hasPendingChanges: 1,
  hasNoTargetSystem: 1,
  hasAvgLowBattery: 1,
  hasAvgMinBattery: 1,
  hasAvgLowSignalStrength: 1,
  hasAvgMinSignalStrength: 1,
};

export type StatusesKeys =
  | 'isBehindSyncingSchedule'
  | 'hasLowBattery'
  | 'hasMinBattery'
  | 'hasLowSignalStrength'
  | 'hasMinSignalStrength'
  | 'hasPendingChanges'
  | 'hasNoTargetSystem'
  | 'hasAvgLowBattery'
  | 'hasAvgMinBattery'
  | 'hasAvgLowSignalStrength'
  | 'hasAvgMinSignalStrength';

export interface Filter {
  readonly category: string;
  readonly value: string;
  description?: string;
  icon?: ReactElement;
  toJSON?(): any;
}

export enum DevicesSortBy {
  SERIAL_NUMBER = 'SERIAL_NUMBER',
  IMEI = 'IMEI',
  MODEL = 'MODEL',
  MEASUREMENTS = 'MEASUREMENTS',
  STATUS = 'STATUS',
  LAST_MEASUREMENT = 'LAST_MEASUREMENT',
  LAST_SYNC = 'LAST_SYNC',
  MAC = 'MAC',
}

export interface SelectableDeviceBoxProps {
  isSelected: boolean;
  device: ListDecoratedMedisanteDevice;
  disableSelect?: boolean;
  onSelectionChanged: (deviceId: string) => void;
  onClipboardClick: (txt: string) => void;
  totalView: boolean;
}

export function GetDeviceModelName(
  device: ListDecoratedMedisanteDevice
): string {
  const model =
    device.properties && device.properties.model
      ? device.properties.model.join(' ')
      : device.model;
  return model;
}
